import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { supabase } from 'services/supabaseClient';
import { useProfile } from './ProfileContext';

const AppAccessContext = createContext();

export function AppAccessProvider({ children }) {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const { profile, loading: profileLoading } = useProfile();

  const fetchApps = useCallback(async () => {
    if (!profile?.id) {
      setApps([]);
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await supabase
        .from('v_effective_user_apps')
        .select('slug')
        .eq('user_id', profile.id);

      if (error) {
        console.error('[AppAccessContext] Error fetching apps:', error.message);
        setApps([]);
      } else {
        setApps(data.map((row) => row.slug));
      }
    } finally {
      setLoading(false); // ✅ only first fetch shows loading
    }
  }, [profile?.id]);

  useEffect(() => {
    if (!profileLoading) {
      fetchApps();
    }
  }, [profileLoading, fetchApps]);

  return (
    <AppAccessContext.Provider
      value={{
        apps,
        loading,
        setApps,
        refreshApps: fetchApps, // keep API for manual refresh
      }}
    >
      {children}
    </AppAccessContext.Provider>
  );
}

export function useAppAccess() {
  return useContext(AppAccessContext);
}
